module.exports = __webpack_public_path__ + "img/small.64256287.jpg";